// extracted by mini-css-extract-plugin
module.exports = {"form-item":"Ruwo3Fxl"};